// this is an autogenerated file from App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Number/Related/Content/Popup/Content/Persons/Person/Relation/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Patients_Content_Content_Sections_ActiveTab_Profile_Content_ContactInfo_Phone_Phones_Content_Phone_Number_Related_Content_Popup_Content_Persons_Person_Relation(
  $from_person_id: numeric!
  $to_person_id: numeric!
  $type: String!
  $opposite_type: String!
) {
  from: insert_vaxiom_relationships_one(
    object: {
      from_person: $from_person_id
      to_person: $to_person_id
      type: $type
      role: "OTHER"
      permitted_to_see_info: false
    }
  ) {
    id
  }
  to: insert_vaxiom_relationships_one(
    object: {
      to_person: $from_person_id
      from_person: $to_person_id
      type: $opposite_type
      role: "OTHER"
      permitted_to_see_info: false
    }
  ) {
    id
  }
}

`